import { inject, Injectable } from '@angular/core';
import { ILoadDetailPlatformApiService } from './load-detail-platform-api.interface';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseApi } from '@domain/shared/infrastructure/models/response-api.interface';
import { map, Observable, take } from 'rxjs';
import { LoadDetailPlatform } from '../domain/LoadDetailPlatform.model';
import { SetMapLoadDetailPlatform, SetMapLoadDetailPlatforms } from '../mappers/load-detail-platform.mappers';
import { LoadDetailPlatformApiModel } from './models/load-detail-platform-api.model';
import { LoadDetailPlatformCreateOrUpdate } from '../domain/LoadDetailPlatformCreateOrUpdate.model';

@Injectable({
  providedIn: 'root'
})
export class LoadDetailPlaformApiService implements ILoadDetailPlatformApiService {
  private readonly BASE_URL = environment.baseUrl;
  private _http = inject(HttpClient);
  
  getAllLoadDetailPlatform(): Observable<LoadDetailPlatform[]> {
    const url = `${this.BASE_URL}load-detail-platform`;
    return this._http.get<ResponseApi>(url).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return [];
        return SetMapLoadDetailPlatforms(
          response.results as LoadDetailPlatformApiModel[]
        );
      })
    );
  }
  
  getLoadDetailPlatformById(
      id: number
  ): Observable<LoadDetailPlatform | null> {
    const url = `${this.BASE_URL}load-detail-platform/${id}`;
    return this._http.get<ResponseApi>(url).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return null;
        return SetMapLoadDetailPlatform(response.results as LoadDetailPlatformApiModel);
      })
    );
  }

  getLoadDetailPlatformByActiviryId(
      activityID: number
  ): Observable<LoadDetailPlatform | null> {
    const url = `${this.BASE_URL}load-detail-platform/activity/${activityID}`;
    return this._http.get<ResponseApi>(url).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return null;
        return SetMapLoadDetailPlatform(response.results as LoadDetailPlatformApiModel);
      })
    );
  }

  getOrCreateLoadDetailPlatform(
      activityID: number
  ): Observable<LoadDetailPlatform | null> {
    const url = `${this.BASE_URL}load-detail-platform/activity/${activityID}`;
    return this._http.post<ResponseApi>(url, {}).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return null;
        return SetMapLoadDetailPlatform(response.results as LoadDetailPlatformApiModel);
      })
    );
  }

  createLoadDetailPlatform(
      createLoadDetail: LoadDetailPlatformCreateOrUpdate
  ): Observable<LoadDetailPlatform | null> {
    const url = `${this.BASE_URL}load-detail-platform`;
    const headers = new HttpHeaders();
    return this._http.post<ResponseApi>(url, createLoadDetail, { headers }).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return null;
        return SetMapLoadDetailPlatform(response.results as LoadDetailPlatformApiModel);
      })
    );
  }

  updateLoadDetailPlatform(
      id: number,
      updateLoadDetail: LoadDetailPlatformCreateOrUpdate
  ): Observable<LoadDetailPlatform | null> {
    const url = `${this.BASE_URL}load-detail-platform/${id}`;
    const headers = new HttpHeaders();
    return this._http.put<ResponseApi>(url, updateLoadDetail, { headers }).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return null;
        return SetMapLoadDetailPlatform(response.results as LoadDetailPlatformApiModel);
      })
    );
  }

  deleteLoadDetailPlatform(id: number): Observable<boolean> {
    const url = `${this.BASE_URL}load-detail-platform/${id}`;
    const headers = new HttpHeaders();
    return this._http.delete<ResponseApi>(url, { headers }).pipe(
      take(1),
      map((response) => {
        return response.ok;
      })
    );
  }
}
